import { Modal, notification, Tabs, Form, Input, Button, Switch, Steps, Select, Row, Col, Badge, Typography, Splitter, Divider, Space } from "antd";
import { useTranslation } from "react-i18next";
import { useGetIdentity } from "@refinedev/core";
import { useEffect, useRef, useState } from "react";
import { getMFAByCurrentUser, getSoftwareToken, getTenantInfo, getTenantMFAInfoByCurrentUser, getUserInTenant, setupSoftwareToken, updateMFAByCurrentUser, updateProperty } from "@/apis";
import { useAuthContext } from "@/providers/auth-provider";
import { useResourceRootContext } from "@/layouts/ResourceContext";
import { MFAUserConfig } from "../common/MFAUserConfig";

const {TabPane} = Tabs;
const { Text } = Typography;
export const UserProfileDialog = ({ visible, onClose }) => {
  const { state } = useResourceRootContext();
  const { user } = useAuthContext();
  const { t } = useTranslation();
  const [form1] = Form.useForm();
  const [form2] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const isSwitch1Checked = Form.useWatch('app', form2);
  const codeValue = Form.useWatch('code', form2)

  const [base64String, setBase64String] = useState("");
  const [enabledMFAs, setEnabledMFAs] = useState([]);
  const [enableMFA, setEnableMFA] = useState(false);
  const [enableAPP, setEnableAPP] = useState(false);
  const [enableSMS, setEnableSMS] = useState(false);
  const [enableEmail, setEnableEmail] = useState(false);

  const mfaRef = useRef();
  useEffect(() => {
    if(user.tenant != "__root__") {
      const getMFAByTenant = async() => {
        const result = await getTenantMFAInfoByCurrentUser();
        /**
         * "email_mfa": true,
        "mfa_config": "ON",
        "app_mfa": true,
        "sms_mfa": false
         */
        if(result) {
          setEnableMFA(result.mfa_config === "ON");
          setEnableAPP(result.app_mfa);
          setEnableSMS(result.sms_mfa);
          setEnableEmail(result.email_mfa);
          setEnabledMFAs(Object.keys(result).filter(key => result[key] === true));
        }
      }
      getMFAByTenant();
    }
  },[user.tenant])

  const handleUserInfoSubmit = () => {
    setLoading(true);
    const fullname = user.fullname;
    const newName = form1.getFieldValue("fullname");
    const updateFullName = async() => {
      const result = await updateProperty({"name": "fullname", "value": newName});
      setLoading(false);
      if("OK" === result?.status) {
        notification.success({
          description: "Change fullname to '" + newName + "' successfully!"
        })
      } else {
        notification.error({
          description: "Change fullname to '" + newName + "' failed!"
        })
        form1.setFieldValue("fullname", fullname);
      }
    }
    updateFullName();
  };

  const onCloseFunc = () => {
    mfaRef?.current?.onClose();
    onClose();
  }

  return (
    <Modal
        title="User Profile"
        open={visible}
        footer={null}
        onCancel={onCloseFunc}
        width={'60%'}
      >
        <Tabs defaultActiveKey="1">
          <TabPane tab="User Info" key="1">
            <Form
              form={form1}
              name="userInfo"
              style={{"width": "80%"}}
              onFinish={handleUserInfoSubmit}
            >
              <Form.Item
                label="Full Name"
                name="fullname"
                initialValue={user.fullname}
                rules={[{ required: true, message: 'Please input the fullname!' }]}
              >
                <Input placeholder="Please input the fullname"/>
              </Form.Item>
              <Form.Item style={{textAlign: 'right'}}>
                <Button type="primary" htmlType="submit" loading={loading}>
                  Submit
                </Button>
              </Form.Item>
            </Form>
          </TabPane>

          <TabPane tab="MFA Setting" key="2" disabled={!enableMFA}>
            <MFAUserConfig ref={mfaRef}/>
          </TabPane>
        </Tabs>
      </Modal>
  );
};
